window.app.controller('offerCtrl', ['$scope', '$http', '$mdDialog', function ($scope, $http, $mdDialog) {

  $scope.file = '';
  $scope.currentFile = 'chwilowki.xlsx';
  $scope.active = true;
  $scope.unit = 12;
  $scope.termDivider = 12;
  $scope.offerCurrentData;
  $scope.offers;
  $scope.uplFileName;
  $scope.show = true;
  $scope.isDraftSaved = false;
  $scope.isOfferDraft = false;

  $scope.offerInfo = {
    decisionPeriod: {
      unit: 'minuty'
    },
    payload: {
      CPL: {
        unit: 'zlotyi'
      },
      CPL1: {
        unit: 'zlotyi'
      },
      CPL2: {
        unit: 'zlotyi'
      },
      CPS: {
        unit: 'zlotyi'
      },
      CPS1: {
        unit: 'zlotyi'
      },
      CPS2: {
        unit: 'zlotyi'
      },
      CPA: {
        unit: 'zlotyi'
      },
      CPA1: {
        unit: 'zlotyi'
      },
      CPA2: {
        unit: 'zlotyi'
      },
    },
    forPensioners: false,
    forStudents: false,
    forUnemployed: false,
    forDebtors: false,
    toBankAccount: false,
    atHome: false,
    byCash: false,
    withoutBikReport: false,
    withoutIncomeCertificate: false,
    needPassport: false,
    applicationOverSMS: false,
    applicationOnline: false,
    increasableAmount: false,
    decreasableAmount: false,
    in15minutes: false,
    withoutVerification: false,
    withoutAnyBases: false,
    withoutCreditAbilities: false,
    forAdult: false,
    for19year: false,
    for20year: false,
    for21year: false,
    for70year: false,
    for84year: false,
    endRepayment: false,
    freeFirstLoan: false,
    inFewPayments: false,
  };

  $scope.bankOfferInfo = {
    decisionPeriod: {
      unit: 'minuty'
    },
    payload: {
      CPL: {
        unit: 'zlotyi'
      },
      CPL1: {
        unit: 'zlotyi'
      },
      CPL2: {
        unit: 'zlotyi'
      },
      CPS: {
        unit: 'zlotyi'
      },
      CPS1: {
        unit: 'zlotyi'
      },
      CPS2: {
        unit: 'zlotyi'
      },
      CPA: {
        unit: 'zlotyi'
      },
      CPA1: {
        unit: 'zlotyi'
      },
      CPA2: {
        unit: 'zlotyi'
      },
    },
    forPensioners: false,
    withoutIncomeCertificate: false,
    needConsolidationDocument: false,
    consolidation: false,
    cashLoan: false,
    toBankAccount: false,
    byCash: false,
    applicationOverSMS: false,
    applicationOnline: false,
    applicationOverBranch: false,
  };

  $scope.constructorCategories = [
    {
      title: 'Chwilówki (spłata na koniec)',
      file: 'chwilowki.xlsx',
      filters: {
        "endRepayment": true,
        "freeFirstLoan": false,
        "inFewPayments": false,
      }
    },
    {
      title: 'Chwilówki (spłata na koniec) ZA DARMO',
      file: 'chwilowki.xlsx',
      filters: {
        "endRepayment": true,
        "freeFirstLoan": true,
        "inFewPayments": false,
      }
    },
    {
      title: 'Pożyczki na raty',
      file: 'pozyczka.xlsx',
      filters: {
        "endRepayment": false,
        "freeFirstLoan": false,
        "inFewPayments": true,
      }
    },
    {
      title: 'Pożyczki na raty ZA DARMO',
      file: 'pozyczka.xlsx',
      filters: {
        "endRepayment": false,
        "freeFirstLoan": true,
        "inFewPayments": true,
      }
    }
  ];

  $scope.getCategoryFile = function () {
    $scope.active ? $scope.offerCurrentData = $scope.offerInfo : $scope.offerCurrentData = $scope.offerItem
    $scope.constructorCategories.forEach(function (element) {
      if (element.title === $scope.offerCurrentData.categoryTitle) {
        $scope.currentFile = element.file;
        $scope.setCategoryFilters(element.filters)
      }
    });
  };

  $scope.setCategoryFilters = function (filters) {
    for (let filter in filters) {
      $scope.active ? $scope.offerInfo[filter] = filters[filter] : $scope.offerItem[filter] = filters[filter];
    }
  }

  $scope.sendInfo = (apiUrl, dataToPass, successFunction) => {
    $scope.sendXHR({
      url: `/rest/affiliateProgram/officeProcess/constructor/${apiUrl}`,
      data: dataToPass,
      successFunc: successFunction,
      errorFunc: $scope.offerFail,
    });
  };

  $scope.createPdl = function () {
    $mdDialog.show({
      preserveScope: true,
      template:
        `<div id="modal-popup" ng-if="show">
                <div class="layout" layout-align="end">
                <span class="modal-close-btn" ng-click="finishCreatingPdl()" aria-label="close">X</span>
                </div>
                <p class="title text-center">Parametry oferty zapisywane i wysłane w celu weryfikacji. Zaczekaj na powiadomienie na twój adres e-mail</p>
            </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    });
  };

  $scope.finishCreatingPdl = () => {
    $mdDialog.hide()
    $scope.uploadFile();
    $scope.sendInfo("create", $scope.offerInfo, $scope.offerRequestSuccess);
  }

  // $scope.sendEdit = function() {
  //     $scope.sendXHR({
  //         url: `/rest/affiliateProgram/officeProcess/constructor/edit`,
  //         data: $scope.offerItem,
  //         successFunc: $scope.reloadPage,
  //         errorFunc: $scope.offerFail,
  //     });
  //     $scope.closeConfirmWindow();
  // };

  $scope.updatePdl = function (objectId) {
    $scope.id = {
      _id: objectId
    };
    // $scope.sendInfo("edit", $scope.offerItem, $scope.reloadPage);
    $mdDialog.show({
      preserveScope: true,
      template:
        `<div id="modal-popup" ng-if="show">
                      <p class="title text-center">Zostawić stronę i zachować zmiany w ofercie?</p>
                      <div class="layout" layout-align="space-between">
                          <button class="action-btn" ng-click="finishUpdatingPdl()" aria-label="yes">Tak</button>
                          <button class="action-btn" ng-click="closeConfirmWindow('${objectId}')" aria-label="no">Nie</button>
                      </div>
                  </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    });
  };

  $scope.finishUpdatingPdl = () => {
    $mdDialog.hide()
    $scope.myFile = document.getElementById('partnerDocEdit').files[0];
    $scope.sendInfo("edit", $scope.offerItem, $scope.offerRequestSuccess);
  }

  $scope.createKredyt = function () {
    $scope.bankOfferInfo.minTerm.unit = $scope.unit;
    $scope.bankOfferInfo.maxTerm.unit = $scope.unit;
    $scope.sendInfo("create", $scope.bankOfferInfo, $scope.reloadPage);
  };

  $scope.updateKredyt = function (objectId) {
    $scope.id = {
      _id: objectId
    };
    $scope.sendInfo("edit", $scope.offerItem, $scope.reloadPage);
  };


  $scope.reloadPage = (resp) => {
    localStorage.setItem('offerHasBeenCreated', true);
    location.reload();
  };

  $scope.offerRequestSuccess = (resp) => {

    // $scope.sendXHR({
    //   url: '/rest/affiliateProgram/officeProcess/constructor/file',
    //   headers: { 'Content-Type': undefined },
    //   transformRequest: function (data) {
    //     var formData = new FormData();
    //     formData.append("file", data.files);
    //     return formData;
    //   },
    //   data: { files: $scope.myFile },
    //   successFunc: location.reload,
    //   errorFunc: $scope.offerFail,
    // });
    // localStorage.setItem('offerHasBeenCreated', true);

    $http({
      method: 'POST',
      url: '/rest/affiliateProgram/officeProcess/constructor/file',
      headers: {'Content-Type': undefined},
      transformRequest: function (data) {
        var formData = new FormData();
        formData.append("file", data.files);
        return formData;
      },
      data: {files: $scope.myFile}
    });
    $scope.reloadPage();
  };


  $scope.offerFail = () => {
    $scope.showAlert('error', 'Fail')
  };

  //OFFER DRAFT

  $scope.saveDraft = () => {
    $scope.sendInfo("draft", $scope.offerInfo, $scope.draftRequestSuccess);
  }

  $scope.updateDraft = (objectId) => {
    $scope.id = {
      _id: objectId
    };
    $scope.sendInfo("draft", $scope.offerItem, $scope.draftRequestSuccess);
  }

  $scope.draftRequestSuccess = (resp) => {
    if (document.getElementById('partnerDoc') && document.getElementById('partnerDoc').files[0]) {
      $scope.myFile = document.getElementById('partnerDoc').files[0];
      $scope.sendFile();
    } else if (document.getElementById('partnerDocEdit') && document.getElementById('partnerDocEdit').files[0]) {
      $scope.myFile = document.getElementById('partnerDocEdit').files[0];
      $scope.sendFile();
    }
    $scope.isDraftSaved = true;
    $mdDialog.show({
      preserveScope: true,
      template:
        `<div id="modal-popup" ng-if="show">
                  <div class="layout" layout-align="end">
                    <span class="modal-close-btn" ng-click="reloadPage()" aria-label="close">X</span>
                  </div>
                    <p class="title text-center">Oferta zapisana jako wersja robocza</p>
                </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    })
  }

  $scope.sendFile = () => {
    $http({
      method: 'POST',
      url: '/rest/affiliateProgram/officeProcess/constructor/file',
      headers: {'Content-Type': undefined},
      transformRequest: function (data) {
        var formData = new FormData();
        formData.append("file", data.files);
        return formData;
      },
      data: {files: $scope.myFile}
    });
  }

  $scope.confirmOfferDeletion = (id) => {
    $mdDialog.show({
      preserveScope: true,
      template:
        `<div id="modal-popup" ng-if="show">
                      <p class="title text-center">Czy na pewno chcesz usunąć ofertę?</p>
                      <div class="layout" layout-align="space-between">
                          <button class="action-btn" ng-click="deleteOffer('${id}')" aria-label="yes">Tak</button>
                          <button class="action-btn" ng-click="hideMdDialog()" aria-label="no">Nie</button>
                      </div>
                  </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    })
  }

  $scope.deleteOffer = (id) => {
    $mdDialog.hide();
    $scope.id = {
      _id: id
    };
    $scope.sendInfo("purge", $scope.id, $scope.reloadPage);
  }

  //OFFER LIST

  $scope.disbaledClass = '';

  $scope.bankCategories = [{
    title: 'Kredyt gotovkoviy'
  }];

  $scope.categories = [
    {
      title: 'Chwilowki(spłata na koniec)',
      selected: 'true'
    },
    {
      title: 'Chwilowki(spłata na koniec) ZA DARMO'
    },
    {
      title: 'Pożyczki na raty'
    },
    {
      title: 'Pożyczki na raty ZA DARMO'
    }
  ];


  $scope.confirmAction = function (str, id) {
    $mdDialog.show({
      // targetEvent: evt,
      preserveScope: true,
      template:
        `<div id="modal-popup" ng-if="show">
                      <p class="title text-center">${str}</p>
                      <div class="layout" layout-align="space-between">
                          <button class="action-btn" ng-click="archiveOffer('${id}')" aria-label="yes">Tak</button>
                          <button class="action-btn" ng-click="closeConfirmWindow('${id}')" aria-label="no">Nie</button>
                      </div>
                  </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    })
  };

  $scope.confirmArchiveOfferChanges = function (str, id) {
    $mdDialog.show({
      preserveScope: true,
      template:
        `<div id="modal-popup" ng-if="show">
                <div class="layout" layout-align="end">
                    <span class="modal-close-btn" ng-click="closeConfirmWindow('${id}')" aria-label="close">X</span>
                </div>
                    <p class="title text-center">${str}</p>
                    <div class="layout" layout-align="space-between">
                        <button class="action-btn" ng-click="archiveOffer('${id}')" aria-label="yes">Tak</button>
                        <button class="action-btn" ng-click="editOffer('${id}')" aria-label="edit">Zmienić przed wysyłką</button>
                    </div>
                </div>`,
      parent: angular.element(document.body),
      scope: $scope,
    })
  };


  $scope.closeConfirmWindow = (id) => {
    $(`#${id}`).removeClass("md-checked")
    $mdDialog.hide();
  }

  $scope.archiveOffer = function (objectId) {
    $scope.id = {
      _id: objectId
    };
    $scope.sendInfo("archive", $scope.id, $scope.reloadPage);
  };

  $scope.editOffer = function (objectId) {
    $scope.closeConfirmWindow();
    $scope.id = {
      _id: objectId
    };
    $scope.sendInfo("read", $scope.id, $scope.cacheData);
  };

  $scope.cacheData = (resp) => {
    (resp.data.finOffer.statusId === 5) ? $scope.isOfferDraft = true : $scope.isOfferDraft = false;
    $scope.offerItem = resp.data.finOffer;
    $scope.active = false;
    $scope.setClick('.tab--partner-offer-constructor');
  };

  $scope.uploadFile = function () {
    $scope.myFile = document.getElementById('partnerDoc').files[0];
  };

  $scope.redirectToConstructor = (requiredFields) => {
    $scope.setClick('.tab--partner-offer-constructor');
    $scope.checkRequiredFields(requiredFields);
  }

  $scope.checkRequiredFields = (requiredFields) => {
    if (requiredFields === "false") {
      $mdDialog.show({
        preserveScope: true,
        template:
          `<div id="modal-popup">
                        <p class="title text-center">Przed stworzeniem oferty wypełnij wymagane pola swojego profilu i dołącz logo w rubryce Profil.</p>
                        <div class="layout" layout-align="center">
                            <button class="action-btn" ng-click="redirectToProfile()" aria-label="go">przejdź</button>
                        </div>
                    </div>`,
        parent: angular.element(document.body),
        scope: $scope,
      })
    }
  }

  $scope.redirectToProfile = () => {
    $mdDialog.hide()
    $scope.setClick('.tab--partner-profile');
  }

  $scope.hideMdDialog = () => {
    $mdDialog.hide();
  };


//Save Draft on Session End
  $scope.popUpOnSessionEnd = (str) => {
    $mdDialog.show({
      preserveScope: true,
      escapeToClose: false,
      template:
        `<div id="modal-popup">
                    <div class="layout" layout-align="end">
                        <span class="modal-close-btn" ng-click="dropLoginToken()" aria-label="close">X</span>
                    </div>
                    <p class="title text-center">${str}</p>
                    <div class="layout" layout-align="center">
                        <button class="action-btn" ng-click="dropLoginToken()" aria-label="understand">Rozumiem</button>
                    </div>
                </div>`,
        parent: angular.element(document.body),
        scope: $scope,
        })
    }

    $scope.dropLoginToken = () => {
      $scope.sendXHR({
        url: `/api/front/authorization/logout/logout`,
        data: "",
        successFunc: $scope.reload,
        errorFunc: "",
      });
    }
    
    $scope.checkIfSessionInProcess = () => {
        if (!sessionStorage.getItem("sessionInProcces")) {
            $scope.sessionInProcces = false;
            sessionStorage.setItem("sessionInProcces", true);
        } else {
            $scope.sessionInProcces = true;
        }
    }

    $scope.setSessionTimer = (timer) => {
        setTimeout(
            function () {
                if($scope.offerData.$dirty && !$scope.isDraftSaved) {
                    $scope.saveDraftOnSessionEnd();
                } else {
                    $scope.popUpOnSessionEnd("Sesja wygasła. Zaloguj się ponownie.");
                }
                sessionStorage.sessionInProcces = '';
                sessionStorage.sessionStartAt = '';
            }, timer);
    }

    $scope.manageSessionTimer = () => {
        $scope.checkIfSessionInProcess();
        if (!$scope.sessionInProcces) {
            let sessionStartTime = (new Date()).getTime();
            sessionStorage.setItem("sessionStartAt", sessionStartTime);
            $scope.setSessionTimer(60000 * 60);
        } else {
            let sessionStart = sessionStorage.getItem("sessionStartAt");
            let currentTime = (new Date()).getTime();
            let timeLeftover = (60000 * 60) - (currentTime - sessionStart);
            $scope.setSessionTimer(timeLeftover);           
        }
    }

    $scope.saveDraftOnSessionEnd = () => {
        $scope.sendInfo("draft", $scope.offerInfo, $scope.saveDraftOnSessionEndSuccess);
        if (document.getElementById('partnerDoc') && document.getElementById('partnerDoc').files[0]){
            $scope.uploadFile();
            $scope.sendFile();
        }
    }

  document.getElementById("partner-contructor").onclick = () => {
    $(window).bind('beforeunload', function () {
      if ($scope.offerData.$dirty && !$scope.isDraftSaved) {
        return "Want to leave without saving offer draft?"
      }
    });
  }
  $scope.saveDraftOnSessionEndSuccess = () => {
    $scope.isDraftSaved = true;
    $scope.popUpOnSessionEnd("Sesja wygasła. Wszystkie dane zostały zapisane");
  }

  $scope.reload = () => {
    location.reload();
  }

  $scope.isDisabled = "disabled";

}]);



// WEBPACK FOOTER //
// src/js/controllers/partner/offerCtrl.js